import { create } from "zustand";

interface ISearchOpenStateStore {
  searchOpen: boolean;
  setSearchOpen: (data: boolean) => void;
}
const useSearchOpenStateStore = create<ISearchOpenStateStore>((set) => {
  return {
    searchOpen:  false,
    setSearchOpen: (searchOpen: boolean) => set(() => ({ searchOpen })),
  };
});

export default useSearchOpenStateStore;
